module.exports = __webpack_public_path__ + "img/denmark-neoplasm-female.0648086d.png";